import React from "react";

export default () => {
  return (
    <div className="search-results__spinner">
      <img src="/assets/img/svg-sprite/loading-squares.svg"/>
    </div>
  );
};